import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { formatPrice, imgUrl } from "../lib/api";
import { useCart } from "../context/CartContext";

const categoryLabel = {
  bois: "Bois",
  verre: "Verre",
  ardoise: "Ardoise",
  flocage: "Flocage",
};

export default function ProductCard({ product, index = 0 }) {
  const { addItem } = useCart();

  return (
    <article
      data-testid={`product-card-${product.id}`}
      className="fade-up bg-white border border-stone-200 rounded-sm overflow-hidden flex flex-col group"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <Link
        to={`/produit/${product.id}`}
        data-testid={`product-link-${product.id}`}
        className="product-image-wrap aspect-[4/3] bg-stone-100 relative block"
      >
        <img
          src={imgUrl(product.image_url)}
          alt={product.name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
        {!product.in_stock && (
          <span className="absolute top-3 left-3 px-2 py-1 text-xs uppercase tracking-wider bg-stone-900 text-white">
            Rupture
          </span>
        )}
        <span className="absolute top-3 right-3 px-2 py-1 text-[10px] uppercase tracking-[0.15em] font-semibold bg-stone-50/95 text-stone-700 border border-stone-200 rounded-sm">
          {categoryLabel[product.category] || product.category}
        </span>
      </Link>

      <div className="p-5 flex flex-col flex-1">
        <Link to={`/produit/${product.id}`} className="font-serif text-xl text-stone-900 leading-snug hover:text-orange-800 transition-colors">
          {product.name}
        </Link>
        {product.description && (
          <p className="mt-2 text-sm text-stone-600 line-clamp-2">{product.description}</p>
        )}
        <div className="mt-4 flex items-end justify-between gap-3">
          <span
            data-testid={`product-price-${product.id}`}
            className="text-2xl font-black text-orange-700 tracking-tight"
          >
            {formatPrice(product.price)}
          </span>
          <button
            data-testid={`add-to-cart-${product.id}`}
            onClick={() => addItem({ ...product, image_url: imgUrl(product.image_url) })}
            disabled={!product.in_stock}
            className="inline-flex items-center gap-1.5 px-3.5 py-2 bg-stone-900 hover:bg-orange-800 disabled:bg-stone-300 disabled:cursor-not-allowed text-white text-sm font-medium rounded-sm transition-colors"
          >
            <Plus size={16} />
            Ajouter
          </button>
        </div>
      </div>
    </article>
  );
}
